<div class="footer-container" *ngIf="isUserLoggedIn()">
  <div class="logo">
    <div style="text-align: left;flex-grow:1;display: flex;align-items: center;justify-content: flex-start;">
      <img src="../../../assets/mfl_footer.png" style="display: inline-block; max-height: 40px;margin-right:5px;">
      <span>Fleet Focus {{theYear}} ©</span>
    </div>
    <span style="margin-left: 15px;">{{userEmail}}</span>
  </div>
</div>
